import { useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { classifyWallUpdate, NO_WALL_UPDATE, WallUpdate } from '../utils'

/**
 * What saving the wall form would do to the saved wall (see `classifyWallUpdate`). A draft isn't
 * saved yet, so anything goes.
 */
const useWallUpdate = (wall: ShapeObject, isDraft: boolean): WallUpdate => {
  const [startX, startY, endX, endY] = useWatch({
    name: ['start.x', 'start.y', 'end.x', 'end.y'],
  }) as number[]

  return useMemo(() => {
    if (isDraft || ![startX, startY, endX, endY].every(Number.isFinite)) return NO_WALL_UPDATE

    const [savedStart, savedEnd] = wall.shape.points
    return classifyWallUpdate(
      { start: savedStart, end: savedEnd },
      { x: startX, y: startY },
      { x: endX, y: endY },
    )
  }, [wall, isDraft, startX, startY, endX, endY])
}

export default useWallUpdate
